import React, {Component} from 'react';

import { Route, Switch } from "react-router-dom";
import {inject} from 'mobx-react';
import VandAMapContainer from './components/map/VandAMapContainer';

@inject('mapStore')
class Routes extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={VandAMapContainer} />

                <Route exact path="/find" component={VandAMapContainer} />
                <Route exact path="/find/whats-on" component={VandAMapContainer} />
                <Route exact path="/find/whats-on/:id" component={VandAMapContainer} />
                <Route exact path="/find/room" component={VandAMapContainer} />
                <Route exact path="/find/room/:id" component={VandAMapContainer} />
                <Route exact path="/find/:id" component={VandAMapContainer} />

                <Route exact path="/where-am-i" component={VandAMapContainer} />
                <Route exact path="/where-am-i/:id" component={VandAMapContainer} />

                <Route exact path="/trails" component={VandAMapContainer} />
                <Route exact path="/trails/:id" component={VandAMapContainer} />
            </Switch>
        )
    }
}

export default Routes;
